import { MonitorCustomerData } from '@Src/_basic/object/MonitorType';
import { Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

interface Props {
  row: MonitorCustomerData;
}
export default function DateColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{moment().format('YYYY/MM/DD HH:mm')}</Typography>;
}
